export const arrayFromObject = (object) =>
  Object.keys(object).reduce((result, key) => [...result, object[key]], []);
